import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Drawer, IconButton, List, ListItem, ListItemText, Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { NavLink, useHistory } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const Navbar = () => {
    const history = useHistory();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Detect smaller screen sizes
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null); // For dropdown menu

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    const handleMenuClick = (category) => {
        setDrawerOpen(false); // Close the drawer
        history.push(`/menu/${category.toLowerCase()}`); // Navigate to the category page
    };

    const handleDropdownClick = (event) => {
        setAnchorEl(event.currentTarget); // Open the dropdown menu
    };

    const handleDropdownClose = (category) => {
        setAnchorEl(null); // Close the dropdown menu
        if (category) {
            history.push(`/menu/${category.toLowerCase()}`); // Navigate to the category page
        }
    };

    const menuItems = [
        { label: 'Home', path: '/' },
        { label: 'Menu', dropdown: ['Lunch', 'Dinner', 'Sunday Brunch', 'Drinks'] },
        { label: 'Reservations', path: '/reservations' },
        { label: 'Contact', path: '/contact' },
        { label: 'Login', path: '/login' },
    ];

    return (
        <AppBar position="sticky" sx={{ backgroundColor: "#9cc476" }}>
            <Toolbar>
                <Typography variant="h6" style={{ flexGrow: 1 }}
                   sx={{
                    fontFamily: "'Brilon', sans-serif",
                    textAlign: 'left',
                    marginTop: '20px',
                    marginBottom: '20px',
                }}>
                    Sugarcane Cafe
                </Typography>
                {isMobile ? (
                    <>
                        <IconButton
                            color="inherit"
                            edge="start"
                            onClick={toggleDrawer(true)}
                            sx={{ color: '#ffffff' }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Drawer
                            anchor="left"
                            open={drawerOpen}
                            onClose={toggleDrawer(false)}
                        >
                            <List sx={{ width: 250 }}>
                                {menuItems.map((item, index) =>
                                    item.dropdown ? (
                                        <React.Fragment key={index}>
                                            <ListItem>
                                                <ListItemText primary={item.label} />
                                            </ListItem>
                                            {item.dropdown.map((subItem, subIndex) => (
                                                <ListItem
                                                    button
                                                    key={subIndex}
                                                    onClick={() => handleMenuClick(subItem)}
                                                >
                                                    <ListItemText primary={subItem} />
                                                </ListItem>
                                            ))}
                                        </React.Fragment>
                                    ) : (
                                        <ListItem
                                            button
                                            key={index}
                                            onClick={() => {
                                                setDrawerOpen(false);
                                                history.push(item.path);
                                            }}
                                        >
                                            <ListItemText primary={item.label} />
                                        </ListItem>
                                    )
                                )}
                            </List>
                        </Drawer>
                    </>
                ) : (
                    <>
                        <Button
                            color="inherit"
                            component={NavLink}
                            to="/"
                            style={{ color: '#ffffff' }}
                            activeStyle={{ fontWeight: 'bold', color: '#614a94' }}
                            sx={{
                                '&:hover': {
                                    color: '#ff9800', // Change color on hover
                                },
                            }}
                        >
                            Home
                        </Button>
                        <Button
                            color="inherit"
                            onClick={handleDropdownClick}
                            style={{ color: '#ffffff' }}
                            sx={{
                                '&:hover': {
                                    color: '#ff9800', // Change color on hover
                                },
                            }}
                        >
                            Menu
                        </Button>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={() => handleDropdownClose(null)}
                        >
                            <MenuItem onClick={() => handleDropdownClose('lunch')}>Lunch</MenuItem>
                            <MenuItem onClick={() => handleDropdownClose('dinner')}>Dinner</MenuItem>
                            <MenuItem onClick={() => handleDropdownClose('brunch')}>Sunday Brunch</MenuItem>
                            <MenuItem onClick={() => handleDropdownClose('drinks')}>Drinks</MenuItem>
                        </Menu>
                        <Button
                            color="inherit"
                            component={NavLink}
                            to="/reservations"
                            style={{ color: '#ffffff' }}
                            activeStyle={{ fontWeight: 'bold', color: '#614a94' }}
                            sx={{
                                '&:hover': {
                                    color: '#ff9800', // Change color on hover
                                },
                            }}
                        >
                            Reservations
                        </Button>
                        <Button
                            color="inherit"
                            component={NavLink}
                            to="/contact"
                            style={{ color: '#ffffff' }}
                            activeStyle={{ fontWeight: 'bold', color: '#614a94' }}
                            sx={{
                                '&:hover': {
                                    color: '#ff9800', // Change color on hover
                                },
                            }}
                        >
                            Contact
                        </Button>
                        <Button
                            color="inherit"
                            component={NavLink}
                            to="/login"
                            style={{ color: '#ffffff' }}
                            activeStyle={{ fontWeight: 'bold', color: '#614a94' }}
                            sx={{
                                '&:hover': {
                                    color: '#ff9800', // Change color on hover
                                },
                            }}
                        >
                            Login
                        </Button>
                    </>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default Navbar;